// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3llPv","checkboxCol":"Table_checkboxCol__1dDFF","emailCol":"Table_emailCol__3f_tM","actionCol":"Table_actionCol__1Huji"};